/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LabTestMethodApi } from '../api/labtestmethod.api';
import { switchMap, map } from 'rxjs/operators';
import { LabTestMethodData, LabTestMethod } from '../../../interfaces/masters/labtestmethod';

@Injectable()
export class LabTestMethodService extends LabTestMethodData {

  constructor(private api: LabTestMethodApi) {
    super();
  }

//   fireRequest(data: Department, method: string) {
//     const links = data.links
//         ? data.links.find(x => x.method === method)
//         : null;
//     switch (method) {
//         case 'DELETE': {
//             return this.api.delete(links.href);
//         }
//         case 'POST': {
//             return this.api.add(links.href,data);
//         }
//         case 'PUT': {
//             return this.api.update(links.href, data);
//         }
//         default: {
//             console.log(`${links.method} not found!!!`);
//             break;
//         }
//     }
// }

  list(url: string): Observable<LabTestMethod[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<LabTestMethod>{
      return this.api.getById(url);
  }

  create(url: string, data:LabTestMethod): Observable<LabTestMethod> {
    return this.api.add(url,data);
  }

  update(url: string, data:LabTestMethod): Observable<LabTestMethod> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
